import React, { useEffect, useState } from "react";
import "./index.scss";
import CardsList from "../../../../core/list-cards";
import { HTTP_METHODS, plainApi } from "../../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../../utils/endpoints";
import { toast } from "react-toastify";
import { Box, Grid, IconButton, Typography } from "@mui/material";
import CustomCard from "../../../../core/custom-card";
import SAMPLE_ENGINE from "../../../../resources/images/engine-model.png";
import { getFileExtensionFromUrl } from "../../../../utils";
import PRODUCTS_IMG from "../../../../resources/images/products.png";
const Product = () => {
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [filters, setFilters] = useState({
    sortBy: "-createdAt",
    page: 1,
    limit: 50,
  });
  const manualCard = (ele) => {
    const addDefaultImg = (ev) => {
      ev.target.src = SAMPLE_ENGINE;
    };
    return (
      <CustomCard>
        <div style={{ cursor: "default" }}>
          <p className="p-margin-0 primary-text worshop-card-text">
            {ele?.engineModel} Series
          </p>
          <Grid container>
            <Grid item md={8}>
              <div className="workshop-engine-img-con">
                <img
                  src={ele?.photo || SAMPLE_ENGINE}
                  alt="engine"
                  width="100%"
                  onError={addDefaultImg}
                />
              </div>
            </Grid>
            <Grid item md={4}>
              <ul>
                {ele?.listData?.map((list) => (
                  <li style={{ wordBreak: "break-all", fontSize: "18px" }}>
                    {list.listNumber}
                  </li>
                ))}
              </ul>
            </Grid>
          </Grid>
        </div>
      </CustomCard>
    );
  };
  const loadData = (filters) => {
    setIsLoading(true);
    plainApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.PRODUCTS}/oem`,
      null,
      filters
    )
      .then((res) => {
        if (res.message) {
          toast.error(res.message);
        } else {
          const result = res?.results
            ?.map((ele, index) => {
              return {
                ...ele,
                sNo: index + 1,
              };
            })
            .filter((ele) => ele && ele);
          setData({ ...res, results: result });
        }
        setIsLoading(false);
      })
      .catch((err) => console.error(err));
  };
  const handleDownload = (ele) => {
    const link = document.createElement("a");
    link.href = ele?.document;
    link.download = `Workshop_Manual_${
      ele?.versionNumber
    }${getFileExtensionFromUrl(ele?.document)}`; // Change extension based on the file type.
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="page-body">
      <div>
        <p className="tab-name">Product</p>
        <p className="section-name">Products Portfolio</p>
      </div>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <img src={PRODUCTS_IMG} alt="Products Image" />
      </div>
      {/* {Object.keys(data).length ? (
        <CardsList
          data={data}
          renderCardFunc={manualCard}
          isLoading={isLoading}
          itemGridSize={3}
          filters={filters}
          onChange={(page) => {
            setFilters((prevVal) => ({ ...prevVal, page }));
            loadData({ ...filters, page });
          }}
        />
      ) : (
        <Typography variant="h4" sx={{ textAlign: "center" }}>
          {" "}
          No Data Found
        </Typography>
      )} */}
    </div>
  );
};

export default Product;
